import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "page-container",
  id: "projects-container"
}
const _hoisted_2 = { class: "opacity-0 mb-20" }
const _hoisted_3 = { class: "relative mb-5 md:mb-20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-44" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-[calc(100%-100px)] md:h-[calc(100%-300px)] w-full absolute z-[-1] top-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ani-height h-0 w-full bg-gradient-to-r from-[#000000] via-[#080F0F] to-[#0A241A]" })
], -1)
const _hoisted_6 = { class: "px-5 md:px-10 max-w-7xl mx-auto" }
const _hoisted_7 = {
  key: 0,
  class: "mb-5 md:mb-10 ani-top"
}
const _hoisted_8 = { class: "font2 text-3xl text-white" }
const _hoisted_9 = {
  key: 1,
  class: "ani-top-now aspect-[2/3] md:aspect-[4/3]"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "w-full h-full keep-all bg-gray-700 block p-10 flex items-center justify-center"
}
const _hoisted_12 = { class: "font1 text-white opacity-50" }
const _hoisted_13 = {
  key: 0,
  class: "max-w-[1575px] mx-auto px-5 md:px-10 mb-5"
}
const _hoisted_14 = { class: "md:flex md:gap-12" }
const _hoisted_15 = {
  key: 0,
  class: "flex-1 ani-top mb-5 md:mb-0"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", { class: "font2 text-3xl" }, "Function", -1)
const _hoisted_17 = { class: "font1 text-xl" }
const _hoisted_18 = {
  key: 1,
  class: "flex-1 ani-top mb-5 md:mb-0"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "font2 text-3xl" }, "Location", -1)
const _hoisted_20 = { class: "font1 text-xl" }
const _hoisted_21 = {
  key: 2,
  class: "flex-1 ani-top"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "font2 text-3xl" }, "Surface", -1)
const _hoisted_23 = {
  key: 0,
  class: "font1 text-xl"
}
const _hoisted_24 = {
  key: 1,
  class: "font1 text-xl"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "max-w-[1575px] mx-auto px-5 md:px-10" }
const _hoisted_27 = { class: "swiper" }
const _hoisted_28 = { class: "swiper-wrapper" }
const _hoisted_29 = ["href"]
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"max-w-[1575px] mx-auto px-10 mt-0 md:mt-10 flex items-center gap-10 flex-row-reverse md:flex-row\"><div class=\"flex-1 overflow-hidden\"><div class=\"swiper-scrollbar-custom h-[1px] bg-[#D3D1D3]\"><div class=\"h-full w-10 bg-[#979797]\"></div></div></div><div class=\"flex gap-2 swiper-buttons\"><a href=\"#\" class=\"swiper-button-prev w-12\"><svg class=\"w-full rotate-180\" xmlns=\"http://www.w3.org/2000/svg\" width=\"106\" height=\"106\" viewBox=\"0 0 106 106\"><g id=\"scroll_down_copy\" data-name=\"scroll down copy\" transform=\"rotate(-90)\"><path id=\"Line_2\" data-name=\"Line 2\" d=\"M0,0-12.8,9.075-25.5,0\" transform=\"translate(-40.335 49.456)\" fill=\"none\" stroke=\"#000\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"4.4\"></path><g id=\"Oval\" transform=\"translate(-106)\" fill=\"none\" stroke=\"#0f0f0f\" stroke-miterlimit=\"10\" stroke-width=\"2.2\"><circle cx=\"53\" cy=\"53\" r=\"53\" stroke=\"none\"></circle><circle cx=\"53\" cy=\"53\" r=\"51.9\" fill=\"none\"></circle></g></g></svg></a><a href=\"#\" class=\"swiper-button-next w-12\"><svg class=\"w-full\" xmlns=\"http://www.w3.org/2000/svg\" width=\"106\" height=\"106\" viewBox=\"0 0 106 106\"><g id=\"scroll_down_copy\" data-name=\"scroll down copy\" transform=\"rotate(-90)\"><path id=\"Line_2\" data-name=\"Line 2\" d=\"M0,0-12.8,9.075-25.5,0\" transform=\"translate(-40.335 49.456)\" fill=\"none\" stroke=\"#000\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"4.4\"></path><g id=\"Oval\" transform=\"translate(-106)\" fill=\"none\" stroke=\"#0f0f0f\" stroke-miterlimit=\"10\" stroke-width=\"2.2\"><circle cx=\"53\" cy=\"53\" r=\"53\" stroke=\"none\"></circle><circle cx=\"53\" cy=\"53\" r=\"51.9\" fill=\"none\"></circle></g></g></svg></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          ($setup.projectitems && $setup.projectitems.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString($setup.decodeEntities($setup.projectitems[0].title.rendered)), 1)
              ]))
            : _createCommentVNode("", true),
          ($setup.projectitems && $setup.projectitems.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                ($setup.projectitems[0]._embedded?.['wp:featuredmedia']?.[0]?.source_url && $setup.projectitems[0]._embedded?.['wp:featuredmedia']?.[0]?.source_url.length > 0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "object-cover object-bottom w-full h-full",
                      src: $setup.projectitems[0]._embedded?.['wp:featuredmedia']?.[0]?.source_url
                    }, null, 8, _hoisted_10))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("h3", _hoisted_12, _toDisplayString($setup.decodeEntities($setup.projectitems[0].title.rendered)) + " image coming soon", 1)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      ($setup.projectitems && $setup.projectitems.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              ($setup.projectitems[0].ACF.function)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("h3", _hoisted_17, _toDisplayString($setup.projectitems[0].ACF.function), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.projectitems[0].ACF.location)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("h3", _hoisted_20, _toDisplayString($setup.projectitems[0].ACF.location), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.projectitems[0].ACF.square_meter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    ($setup.projectitems[0].ACF.location.includes('UK'))
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_23, _toDisplayString($setup.projectitems[0].ACF.square_meter.replace('m²', 'sq.ft')), 1))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_24, _toDisplayString($setup.projectitems[0].ACF.square_meter), 1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.projectitems && $setup.projectitems.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectitems[0].ACF.portfolio_gallery, (portfolio_gallery) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "swiper-slide aspect-[3/2]",
                      key: portfolio_gallery.id
                    }, [
                      _createElementVNode("a", {
                        href: portfolio_gallery.url,
                        "data-fancybox": "gallery"
                      }, [
                        _createElementVNode("img", {
                          class: "object-cover w-full h-full",
                          src: portfolio_gallery.url
                        }, null, 8, _hoisted_30)
                      ], 8, _hoisted_29)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_31
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}